// 查看备注
import React from 'react';
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { component_tool } from '@/tool';
const { WizCard, WizComponent } = component_tool;

class LookRemark extends WizComponent {

  componentName = 'LookRemark'

  constructor(props) {
    super(props)
    this.state = {

    }
  }

  _componentDidMount() {

  }

  getImgInfo = () => {
    let { imgFileId } = this.props
    let url = getOssFilePath(imgFileId)
    return imgFileId ?
    (
      <>
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginRight: 0, }}>
          <PhotoProvider
            toolbarRender={({ onScale, scale }) => {
              return (
                <>
                  <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)} />
                  <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)} />
                </>
              );
            }}>
            <div className="foo">
              <PhotoView key={'remark_img_'+ 1} src={url}>
                <img  height={207 / 3} width={400 / 3} src={url}  alt=""/>
              </PhotoView>
            </div>
          </PhotoProvider>
        </div>
      </>
    ) : '无'
  }
  render() {
    let { remark,imgFileId } = this.props
    return (
      <React.Fragment>
        <WizCard>
          <Descriptions column={1}>
            <Descriptions.Item label='图片备注'>{this.getImgInfo()}</Descriptions.Item>
            <Descriptions.Item label='备注'>
              <div style={{ width: 500 ,display: 'flex', justifyContent: 'flex-start', marginRight: 0, }}>
                {remark}
              </div>
            </Descriptions.Item>
          </Descriptions>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {

  return {}

}

export default connect(mapStateToProps)(LookRemark)



